import * as React from 'react';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { RequirePermission } from '@klareospace/pharos-lib-front-utils';
import { ActionBar, ActionBarSpacer, Button, InfoPopover } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

interface OrderTypesActionBarProps {
  onAdd: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function OrderTypesActionBar({ onAdd }: OrderTypesActionBarProps): React.JSX.Element {
  const { t } = useTranslation('settings');

  return (
    <ActionBar>
      <ActionBarSpacer />
      <InfoPopover
        description={t('orderTypes.actionBar.tooltip.body')}
        title={t('orderTypes.actionBar.tooltip.title')}
      />
      <RequirePermission permission="order-types:manage">
        <Button
          className="h-9 gap-1.5 rounded-md px-3 text-sm shadow-sm hover:shadow-md"
          onClick={onAdd}
          variant="default"
        >
          <Plus className="h-4 w-4" />
          {t('orderTypes.actionBar.addOrderType')}
        </Button>
      </RequirePermission>
    </ActionBar>
  );
}
